import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import SocialSign from './SocialSign';
import { UserContext } from "../../context/UserContext";
import { useAuth } from "../../context/AuthContext";
import PopUpVerificationCode from '../Shared/PopUpVerificationCode/PopUpVerificationCode';
import { useGoogleLogin } from "@react-oauth/google";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const EMAIL_REGEX = /\S+@\S+\.\S+/;

const SignIn = ({ handleResponse }) => {
  const { login, googleLogin } = useAuth();
  const navigate = useNavigate();
  const { setUser, setIsLoggedIn } = useContext(UserContext);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isEmailChecking, setIsEmailChecking] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showVerificationPopup, setShowVerificationPopup] = useState(false);

  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const validateFields = async () => {
    let isValid = true;
    const newErrors = {};

    if (!email.trim()) {
      newErrors.email = "Adres email jest wymagany";
      isValid = false;
    } else if (!EMAIL_REGEX.test(email)) {
      newErrors.email = "Podaj poprawny adres email";
      isValid = false;
    } else {
      setIsEmailChecking(true);
      try {
        const response = await fetch(`${API_BASE_URL}/api/user/checkEmail?email=${encodeURIComponent(email)}`);
        if (response.ok) {
         let exists = false;
         const contentType = response.headers.get("content-type") || "";
         if (contentType.includes("application/json")) {
          const data = await response.json();
          exists = typeof data === "boolean" ? data : !!data.exists;
         } else {
          const text = (await response.text()).trim().toLowerCase();
          exists = text === "true";
         }
         if (!exists) {
            newErrors.email = "Konto z podanym emailem nie istnieje.";
            isValid = false;
          }
        } else {
          console.error("Błąd przy sprawdzaniu e-maila");
        }
      } catch (error) {
        console.error("Wystąpił błąd podczas sprawdzania e-maila:", error);
      }
      setIsEmailChecking(false);
    }

    if (!password.trim()) {
      newErrors.password = "Hasło jest wymagane";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!(await validateFields())) return;

    const userData = { email, password };

    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(userData),
      });

      const data = await response.json();
      if (response.ok) {
        const user = data.user;
        if (!user.enabled) {
          setShowVerificationPopup(true);
          return;
        }
        login(data.token, data.user);
        navigate("/");
      } else if (response.status === 403 && data.message === "Account not verified") {
        setShowVerificationPopup(true);
      } else if (
        response.status === 401 &&
        /invalid/i.test((data?.message || "")) //
      ) {
        setErrors((prev) => ({
          ...prev,
          password: "Nieprawidłowe hasło",
        }));
        setPassword("");
        return;
      } else {
        setErrors((prev) => ({
          ...prev,
          password: "Wystąpił błąd logowania. Spróbuj ponownie.",
        }));
      }
    } catch (error) {
      console.error("Wystąpił błąd:", error);
      setErrors((prev) => ({
        ...prev,
        password: "Wystąpił błąd sieci. Spróbuj ponownie.",
      }));
    }
  };

  return (
    <>
      <form className="sign-in-form" onSubmit={handleSubmit} noValidate>
        <h2 className="title">Zaloguj się</h2>

        <div className="input-field">
          <span className="fIcon"><FaEnvelope /></span>
          <input
            placeholder="Email"
            name="email"
            type="email"
            value={email}
            onInvalid={(e) => e.preventDefault()}
            onChange={(e) => {
              setEmail(e.target.value);
              if (errors.email) setErrors((prev) => ({ ...prev, email: "" }));
            }}
            aria-invalid={!!errors.email}
            aria-describedby={errors.email ? "email-error" : undefined}
          />
          {errors.email && <small id="email-error" className="error-text">{errors.email}</small>}
        </div>

        <div className="input-field password-field">
          <span className="fIcon"><FaLock /></span>
          <input
            placeholder="Hasło"
            name="password"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              if (errors.password) setErrors((prev) => ({ ...prev, password: "" }));
            }}
            aria-invalid={!!errors.password}
            aria-describedby={errors.password ? "password-error" : undefined}
          />
          <span className="password-toggle" onClick={() => setShowPassword((prev) => !prev)}>
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
          {errors.password && <small id="password-error" className="error-text">{errors.password}</small>}
        </div>

        <button type="submit" className="btn btn-primary btn-block mt-2 iBtn">
          ZALOGUJ
        </button>
      </form>

      {showVerificationPopup && (
        <PopUpVerificationCode
          email={email}
          visible={true}
          onClose={() => setShowVerificationPopup(false)}
          onVerified={() => {
            setShowVerificationPopup(false);
            handleSubmit({ preventDefault: () => {} });
          }}
        />
      )}
    </>
  );
};

export default SignIn;
